import React from "react";
import moment from "moment/moment";
import { UserInterface } from "../../../../interfaces/private/UserInterface";

interface Props {
    user: UserInterface | null;
}

const DetailRow = ({ label, value }: { label: string; value: React.ReactNode }) => (
    <div className="row mb-2">
        <div className="col-4 text-muted">{label}</div>
        <div className="col-8">{value || '—'}</div>
    </div>
);

const BodyModalUserDetailComponent: React.FC<Props> = ({ user }) => {
    if (!user) {
        return null;
    }

    const address = [
        user.address,
        user.zip,
        user.city,
        user.country,
    ].filter(Boolean).join(', ');

    return (
        <div>
            <DetailRow label="ID" value={user.id} />
            <DetailRow label="Email" value={user.email} />
            <DetailRow label="Agreement No" value={user.account_number} />
            <DetailRow label="Name" value={user.name} />
            <DetailRow label="Company" value={user.company_name} />
            <DetailRow label="Address" value={address} />
            <DetailRow label="CVR No" value={user.cvr_no} />
            <DetailRow label="Phone" value={user.phone} />
            <DetailRow label="Website" value={user.website} />
            <DetailRow
                label="Version"
                value={
                    <span className={`badge ${user.sync_engine_version === 'v2' ? 'bg-primary' : 'bg-secondary'}`}>
                        {(user.sync_engine_version || 'v1').toUpperCase()}
                    </span>
                }
            />
            <DetailRow
                label="Created At"
                value={
                    moment(user.created_at).isValid()
                        ? moment(user.created_at).format('DD.MM.YYYY HH:mm')
                        : null
                }
            />
            <DetailRow
                label="Status"
                value={user.status ? 'Active' : 'Inactive'}
            />
        </div>
    );
};

export default BodyModalUserDetailComponent;
